/**
 * IMPORTANT: The widget rendering system has been decommissioned.
 *
 * This file is maintained only to prevent breaking imports in existing third-party customizations.
 * New code should not use this component or the widget system.
 */

/**
 * This class is kept only for backward compatibility.
 *
 * @deprecated This class is part of the decommissioned widget system and should not be used anymore.
 */
export const ButtonClass = {
  /**
   * @deprecated the widget rendering system was decommissioned
   */
  buildClasses() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  buildAttributes() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  _buildIcon() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  html() {},

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  click() {},
};

export { DummyWidget as default } from "discourse/widgets/widget";
